export const createAttribute = (mapSubscribableThing, mutations, prependSubscribableThing) => {
    return (htmlElement, name) => {
        const getAttribute = () => htmlElement.getAttribute(name);
        return prependSubscribableThing(mapSubscribableThing(mutations(htmlElement, {
            attributeFilter: [name],
            childList: false,
            subtree: false
        }), () => getAttribute()), getAttribute());
    };
};
//# sourceMappingURL=attribute.js.map